<ion-content color="light">
  <ion-toolbar>
    <ion-title>Edit Day</ion-title>
    <ion-buttons slot="end">
      <ion-button color="light" (click)="closeModal()"
        ><ion-icon name="close-circle-outline"></ion-icon></ion-button
      >
    </ion-buttons>
  </ion-toolbar>

  <div class="w-[90%] my-4 mx-auto">
    <form [formGroup]="editDayForm" class="space-y-3">
      <!-- <div class="my-1 mx-1">
        <label
          for="first-name"
          class="block text-sm font-medium text-[#797979]"
          >Dwell Date</label
        >
        <div class="mt-1">
          <input
            type="date"
            formControlName="dwell_date"
            class="block w-full   rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          />
        </div>
      </div> -->
      <div class="my-1">
        <label
          for="first-name"
          class="block text-sm font-medium text-[#797979]"
          >Monitoring Date<span style="color: red;">*</span></label
        >
        <div class="mt-1">
          <input
            type="date"
            formControlName="monitoring_date"
            max="{{ today | date:'yyyy-MM-dd' }}"
            class="block w-full   rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          />
        </div>
        <p
          class="mt-2 text-sm text-red-600"
          id="firstname-error"
          *ngIf="editDayForm.get('monitoring_date')?.hasError('required') && (editDayForm.get('monitoring_date')?.touched || editDayForm.get('monitoring_date')?.dirty)"
        >
          Monitoring Date is required
        </p>
      </div>

      <div class="my-1">
        <label
          for="first-name"
          class="block text-sm font-medium text-[#797979]"
          >Idle Lumens Clamped</label
        >
        <div class="mt-1">
          <ng-select
          class="w-[100%]  h-[37px] rounded-md border-gray-300"
          formControlName="clamped"
          name="clamped"
          [searchable]="false"
          [clearable]="false"
        >
          <ng-option [value]="null">Select an option</ng-option>
          <ng-option [value]="'Infusing'">Infusing</ng-option>
          <ng-option [value]="'No'">No</ng-option>
          <ng-option [value]="'Yes'">Yes</ng-option>
          </ng-select>
        </div>
      </div>
      <div class="my-1">
        <label
          for="first-name"
          class="block text-sm font-medium text-[#797979]"
          >Securement Device</label
        >
        <div class="mt-1">
          <ng-select
            class="w-[100%]  h-[37px] rounded-md border-gray-300"
            formControlName="securement"
            [searchable]="false"
            [clearable]="false"
          >
            <ng-option [value]="null">Select an option</ng-option>
            <ng-option [value]="'Cath Securement Drsg'">Cath Securement Drsg</ng-option>
            <ng-option [value]="'None'">None</ng-option>
            <ng-option [value]="'Sutured'">Sutured</ng-option>
            <ng-option [value]="'Sutureless Device'">Sutureless Device</ng-option>
          </ng-select>
        </div>
        <p
          class="mt-2 text-sm text-red-600"
          id="firstname-error"
          *ngIf="editDayForm.get('securement')?.hasError('required') && (editDayForm.get('securement')?.touched || editDayForm.get('securement')?.dirty)"
        >
          Securement is required
        </p>
      </div>
      <div class="my-1 sm:col-span-3">
        <label
          for="first-name"
          class="block text-sm font-medium text-[#797979]"
          >Reason for D/C
        </label>
        <div class="mt-1">
          <ng-select
            class="w-[100%]  h-[37px] rounded-md border-gray-300"
            formControlName="dc_reason"
            [items]="dcReasons"
            bindValue="id"
            bindLabel="name"
            [searchable]="false"
            [clearable]="false"
          >
            <ng-option [value]="null">Select an option</ng-option>
          </ng-select>
        </div>
        <p
          class="mt-2 text-sm text-red-600"
          id="firstname-error"
          *ngIf="editDayForm.get('dc_reason')?.hasError('required') && (editDayForm.get('dc_reason')?.touched || editDayForm.get('dc_reason')?.dirty)"
        >
          Reason is required
        </p>
      </div>
      <div class="my-1 sm:col-span-3">
        <label for="first-name" class="block text-sm font-medium text-[#797979]"
          >Device Related Adverse Events</label
        >
        <div>
          <ng-select
            class="w-[100%] mt-1 h-[37px] rounded-md border-gray-300"
            formControlName="device_related_adverse_events"
            name="vessel"
            [searchable]="false"
            [clearable]="false"
          >
            <ng-option [value]="null">Select an option</ng-option>
            <ng-option [value]="'Air Embolism'">Air Embolism</ng-option>
            <ng-option [value]="'Arterial Puncture'">Arterial Puncture</ng-option>
            <ng-option [value]="'Bleeding'">Bleeding</ng-option>
            <ng-option [value]="'Bacteremia'">Bacteremia</ng-option>
            <ng-option [value]="'Catheter Embolism'">Catheter Embolism</ng-option>
            <ng-option [value]="'Exit Site Infection'">Exit Site Infection</ng-option>
            <ng-option [value]="'Fibrin Sheath'">Fibrin Sheath</ng-option>
            <ng-option [value]="'Hematoma'">Hematoma</ng-option>
            <ng-option [value]="'Infiltration'">Infiltration</ng-option>
            <ng-option [value]="'Malposition'">Malposition</ng-option>
            <ng-option [value]="'Nerve Injury'">Nerve Injury</ng-option>
            <ng-option [value]="'Occlusion'">Occlusion</ng-option>
            <ng-option [value]="'Phlebitis'">Phlebitis</ng-option>
            <ng-option [value]="'Septicemia'">Septicemia</ng-option>
            <ng-option [value]="'Thrombophlebitis'">Thrombophlebitis</ng-option>
            <ng-option [value]="'Venous Thrombosis'">Venous Thrombosis</ng-option>
            <ng-option [value]="'vessel Erosion'">Vessel Erosion</ng-option>
          </ng-select>
        </div>
      
      </div>
      <div class="my-1">
        <label
          for="first-name"
          class="block text-sm font-medium text-[#797979]"
          >Notes</label
        >
        <div class="mt-1">
          <input
            type="text"
            formControlName="notes"
            class="block   w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          />
        </div>
      </div>
      <div class="sm:col-span-3 block">

       

        <div class="mt-1 flex items-center">
          <input
            value="true"
            type="checkbox"
            formControlName="blood_return"
            class="block rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          />
          <label for="first-name" class="ml-2 block text-sm font-medium text-[#797979]"
          >Blood Return</label
        >
        </div>
        <div class="mt-1 flex items-center">
          <input
            value="true"
            type="checkbox"
            formControlName="completed_therapy"
            class="block rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          />
          <label for="first-name" class="ml-2 block text-sm font-medium text-[#797979]"
          >Completed Therapy</label
        >
        </div>
        <div class="mt-1 flex items-center">
          <input
            value="true"
            type="checkbox"
            formControlName="dressing_intact"
            class="block rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          />
          <label for="first-name" class="ml-2 block text-sm font-medium text-[#797979]"
          >Dressing Intact</label
        >
        </div>
        <div class="mt-1 flex items-center">
          <input
            value="true"
            type="checkbox"
            formControlName="flushes"
            class="block rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          />
          <label for="first-name" class="ml-2 block text-sm font-medium text-[#797979]"
          >Flushes</label
        >
        </div>
      </div>


    </form>
    <div class="pt-8 md:pt-4 flex justify-between items-center space-x-2">
      <button
        (click)="closeModal()"
        class="w-full rounded-[5px] h-[40px] !bg-[#58585A] text-white"
        >
          Cancel
      </button>
      <ion-button [disabled]="!editDayForm.valid" class="w-full h-[40px] min-h-10" expand="block" (click)="submit()"
        >Edit Day</ion-button
      >
    </div>
  </div>
</ion-content>